export default "__VITE_ASSET__CXtjAykN__"